import { useCallback } from "react";

import ResponseError from "@/errors/ResponseError";
import { API_BASE_URL } from "@/api/api.config";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

interface ClassRoomGetHookResponse<T> {
  data: T;
  error: ResponseError;
  loading: boolean;
}

type ClassRoomGetHook<T> = [
  (params?: Record<string, string | undefined>) => ClassRoomGetHookResponse<T>,
  ClassRoomGetHookResponse<T>,
];

const useLazyClassroomGetList = <T>(): ClassRoomGetHook<T> => {
  const classroomSearch = useCallback(
    (
      payload?: string | string[][] | Record<string, string> | URLSearchParams,
    ) => {
      const searchParams = new URLSearchParams(payload);
      return new Request(
        `${API_BASE_URL}/api/v2/classroom/?${searchParams.toString()}`,
      );
    },
    [],
  );

  return useLazyRestQuery(classroomSearch) as ClassRoomGetHook<T>;
};

export default useLazyClassroomGetList;
